<template>
  <div class="hidden-sm-and-up header-classification shop-header-element-ui-less">
    <el-row class="main_dingbu">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" >
        <div>
          <img src="../../../../assets/home/logo.png" style="width: 50%;height: 50%" />
        </div>
        <div class="main_phone_shaixuan">
          <i class="el-icon-menu" width="40px"
             @click="is_open.phone_shaixuan===1?is_open.phone_shaixuan=0:is_open.phone_shaixuan=1"
             style="color: #FFFFFF;font-size: 40px;margin-top: 8px;margin-left: 10px"></i>
          <i class="el-icon-search"
             @click="is_open.phone_sousuokuang===1?is_open.phone_sousuokuang=0:is_open.phone_sousuokuang=1"
             style="color: #FFFFFF;font-size: 35px;
              float: right;margin-top: 10px;margin-right: 10px;"></i>
        </div>
        <div class="main_phone_shaixuan_neirong" v-if="is_open.phone_shaixuan==1">
          <div class="main_phone_shaixuan_neirong_text">分析仪器</div>
          <div class="main_phone_shaixuan_neirong_text">二手仪器</div>
          <div class="main_phone_shaixuan_neirong_text">实验室通用设备</div>
          <div class="main_phone_shaixuan_neirong_text">光学设备</div>
          <div class="main_phone_shaixuan_neirong_text">通用设备</div>
          <div class="main_phone_shaixuan_neirong_text">行业专用仪器</div>
          <div class="main_phone_shaixuan_neirong_text">工业材料</div>
        </div>
        <div class="main_phone_sousuo_neirong" v-if="is_open.phone_sousuokuang==1">
          <div style="margin-top: 40px">
            <el-input size="small " placeholder="请输入内容" v-model="input3" class="input-with-select">
              <el-select class="xujz" v-model="select" slot="prepend" placeholder="请选择">
                <el-option label="在线商品" value="1"></el-option>
                <el-option label="在线服务" value="2"></el-option>
                <el-option label="成功案例" value="3"></el-option>
                <el-option label="仪才秀" value="3"></el-option>
                <el-option label="小星点灯" value="3"></el-option>
                <el-option label="应用方案" value="3"></el-option>
              </el-select>
              <el-button slot="append">搜索</el-button>
            </el-input>
          </div>

        </div>
      </el-col>

    </el-row>
  </div>
</template>
<script>
export default {
  name: 'App',
  data: function () {
    return {
      is_open: {
        sousuo: 1,
        lanmu: 1,
        phone_shaixuan: 0,
        phone_sousuokuang: 0,
      },
      information: '',
    }
  },
  methods: {
    sousuo_xuanxiang(e) {
      this.is_open.sousuo = e
      console.log(this.is_open.sousuo)
    },
    init() {
      this.information = this.$store.state.information
      console.log(this.$store.state.information, 8848)
    }
  },
  created() {
    this.init()
  }

}
</script>
<style lang="less">
.header-classification{
  .main_dingbu {
    width: 100%;
    background: #F9F9F9;

    .main_phone_shaixuan {
      height: 60px;
      width: 100%;
      background-color: #2f549f;
    }

    .main_phone_shaixuan_neirong {
      width: 100%;
      height: 365px;
      //padding-right: 15px;
      //padding-left: 15px;
      background-color: #2f549f;

      .main_phone_shaixuan_neirong_text {
        padding-left: 15%;
        height: 50px;
        font-size: 20px;
        line-height: 50px;
        color: #FFFFFF;
        border: 1px solid rgba(0, 0, 0, .2);

      }
    }

    .main_phone_sousuo_neirong {
      height: 70px;

      .main_phone_sousuo_kuang {
        float: left;
        margin-top: 10px;
        margin-left: 10%;
        width: 300px;
        height: 51px;
        border: 3px solid #2f549f;
      }
    }

    .main_fenlan {
      width: 80%;
      max-width: 1200px;
      height: 430px;
      //background: #FFFFFF;
      border-radius: 3px;
      margin-right: auto;
      margin-left: auto;

      .main_fenlan_neirong {
        float: left;
        width: 220px;
        height: 430px;
        background: #FFFFFF;
        opacity: 0.95;

        .main_fenlan_neirong_list {
          width: 100%;
          height: 62px;

          .main_fenlan_neirong_list_img {
            width: 20px;
            height: 20px;
            margin-top: 21px;
            margin-left: 17px;
            float: left;
          }

          .main_fenlan_neirong_list_text {
            font-size: 18px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
            float: left;
            margin-top: 18px;
            margin-left: 13px;
            //line-height: 100px;
          }
        }
      }

      .main_lunbo {
        float: left;
        //margin-left: 15px;
        margin-top: 15px;
        width: 720px;
        height: 415px;
      }

      .main_fenglu {
        float: left;
        width: 230px;
        height: 414px;
        background: #FFFFFF;
        border-radius: 5px;
        margin-top: 15px;
        //margin-left: 15px;

        .main_fenglu_fenge {
          width: 183px;
          height: 1px;
          background: #F1F1F1;
          border-radius: 1px;
          position: absolute;
          margin-top: 114px;
          margin-left: 24px;
        }

        .main_fenglu_huanyi {
          //width: 84px;
          //height: 22px;
          font-size: 22px;
          float: left;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #333333;
          margin-left: 24px;
          margin-top: 24px;
          //line-height: 100px;
        }

        .main_fenglu_huanyi2 {
          //width: 56px;
          //height: 14px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #999999;
          float: left;
          position: absolute;
          margin-top: 33px;
          margin-left: 114px;
          //line-height: 100px;
        }

        .main_fenglu_button {
          width: 80px;
          color: #4E6EF2;
          height: 24px;
          background: #FFFFFF;
          border: 1px solid #4E6EF2;
          border-radius: 4px;
          position: absolute;
          margin-left: -80px;
          margin-top: 70px;
        }

        .main_fenglu_button2 {
          color: #FFFFFF;
          width: 80px;
          height: 24px;
          border: none;
          background: linear-gradient(-30deg, #6789F4 0%, #4E6EF2 100%);
          border-radius: 4px;
          position: absolute;
          margin-left: 16px;
          margin-top: 70px;
        }

        .main_fenglu_rukou {
          width: 76px;
          height: 76px;
          //background: #888888;
          float: left;

          .main_fenglu_rukou_beijing {
            width: 36px;
            height: 36px;
            background: linear-gradient(0deg, #4E6EF2 0%, #7E9BF5 100%);
            border-radius: 50%;
            margin-left: 19px;
            margin-top: 12px;

            .main_fenglu_rukou_beijing_img {
              margin-left: 7px;
              margin-top: 8px;
            }
          }

          .main_fenglu_rukou_text {
            margin-top: 4px;
            margin-left: 17px;
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #666666;
            //line-height: 100px;
          }
        }

        .main_fenglu_fubiao {
          width: 192px;
          margin-left: 20px;
          margin-top: 140px;
          //height: 40px;
        }

        .main_fenglu_fubiao2 {
          width: 192px;
          margin-left: 20px;
          margin-top: 200px;
        }

        .el-divider {
          background-color: #333333;
        }

        .el-divider--horizontal {
          height: 1px;
        }

        .el-divider__text {
          padding: 0 5px;
        }

        .main_fenglu_pingtai {
          float: left;
          //width: 57px;
          //height: 14px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
          margin-left: 15px;
          //line-height: 100px;
        }
      }
    }

    .main_pinpai_jiange {
      width: 100%;
      height: 85px;

    }

    .main_pinpai {
      width: 80%;
      max-width: 1200px;
      //height: 300px;
      background: #FFFFFF;
      border-radius: 3px;
      margin-right: auto;
      margin-left: auto;

      .main_pinpai_jiange_biaoti {
        font-size: 30px;
        margin-top: -52px;
        position: absolute;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
        //line-height: 100px;
      }

      .main_pinpai_logo_fenge {
        width: 1100px;
        height: 1px;
        background: #F1F1F1;
        position: absolute;
        margin-top: 150px;
        margin-left: 50px;
      }

      .main_pinpai_logo_neirong {
        //height: 100px;
        width: 100%;
        float: left;

        /*.main_pinpai_logo_neirong_img {*/
        /*  width: 100%;*/
        /*  height: 100%;*/
        /*  //margin-top: 35px;*/
        /*  //margin-left: 68px;*/
        /*}*/
      }

      .main_pinpai_logo_fenge_right {
        width: 1px;
        height: 100px;
        background: #F1F1F1;
        float: left;
        margin-top: 25px;
      }
    }

    .main_shangpin {
      width: 80%;
      max-width: 1200px;
      height: 750px;
      //background: #FFFFFF;
      border-radius: 3px;
      margin-right: auto;
      margin-left: auto;

      .main_shangpin_lanmu {
        width: 100%;
        height: 80px;
        background: #FFFFFF;
        text-align: center;
        border-radius: 2px;
        line-height: 130px;

        .main_shangpin_lanmu {
          display: table-cell;
          vertical-align: middle;

          .main_shangpin_lanmu_img {
            display: inline-block;
          }
        }

        .main_shangpin_hentiao_left {
          position: absolute;
          margin-top: 33px;
          margin-left: 398px;
          float: left;
          width: 116px;
          height: 6px;
          background: linear-gradient(90deg, rgba(209, 195, 252, 0) 0%, #814CE4 100%);
        }

        .main_shangpin_hentiao_left2 {
          width: 64px;
          height: 4px;
          position: absolute;
          float: left;
          margin-top: 40px;
          margin-left: 450px;
          background: linear-gradient(90deg, rgba(209, 195, 252, 0) 0%, #814CE4 100%);
        }

        .main_shangpin_hentiao_right {
          position: absolute;
          margin-top: -40px;
          margin-left: 680px;
          width: 116px;
          height: 6px;
          background: linear-gradient(-90deg, rgba(209, 195, 252, 0) 0%, #814BE4 100%);
        }

        .main_shangpin_hentiao_right2 {
          width: 64px;
          height: 4px;
          position: absolute;
          margin-top: -32px;
          margin-left: 681px;
          background: linear-gradient(-90deg, rgba(209, 195, 252, 0) 0%, #814BE4 100%);
        }

        .main_shangpin_lanmu_text {
          text-align: center;
          //width: 124px;
          //height: 29px;
          //  float: contour;
          //  top: 20px;
          padding-top: 14px;
          //  margin-top: 20px;
          font-size: 30px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #834CE4;
          //line-height: 100px;
        }

        .main_shangpin_lanmu_text2 {
          text-align: center;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #666666;
          //line-height: 100px;
        }
      }

      .main_shangpin_neirong {
        width: 100%;
        height: 320px;
        background: #FFFFFF;
        border-radius: 3px;
        float: left;
        margin-top: 20px;
        margin-right: 15px;
        text-align: left;
        position: relative;

        .main_shangpin_neirong_img {
          width: 100%;
          height: 215px;
          //background: #aa7700;
        }

        .main_shangpin_neirong_biaoqian {
          //margin-left: auto;
          //margin-right: auto;
          text-align: center;
          width: 60px;
          position: absolute;
          height: 24px;
          border: 1px solid #8450E4;
          border-radius: 2px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #854FE5;
          float: right;
          margin-top: -210px;
          right: 5px;
          //margin-left: 100px;
          line-height: 24px;
        }

        .main_shangpin_neirong_biaoti {
          //width: 176px;
          //height: 34px;
          font-size: 14px;
          margin-left: 20px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #333333;
          line-height: 20px;
          width: 80%;

        }

        .main_shangpin_neirong_haopin {
          float: left;
          width: 60px;
          height: 12px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 100;
          color: #999999;
          line-height: 20px;
          margin-left: 20px;
          margin-top: 11px;
        }

        .main_shangpin_neirong_jiage {
          width: 79px;
          height: 13px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #F03726;
          line-height: 20px;
          margin-left: 19px;
          margin-top: 40px;
        }
      }
    }

    .main_fuwuzhida {
      width: 80%;
      max-width: 1200px;
      height: 370px;
      //background: #FFFFFF;
      border-radius: 3px;
      margin-right: auto;
      margin-left: auto;

      .main_fuwuzhida_fenmian {
        float: left;
        background: #FFFFFF;
        background-image: url("../../../../assets/home/fuwuzhida.png");
        width: 471px;
        height: 240px;

        .main_fuwuzhida_fenmian_img {
          width: 235px;
        }

        .main_fuwuzhida_fenmian_text {
          float: left;
          width: 157px;
          height: 36px;
          font-size: 38px;
          font-family: SweiAxSansCJKtc;
          font-weight: 500;
          color: #6783F9;
          line-height: 30px;
          margin-top: 81px;
          margin-left: 266px;
        }

        .main_fuwuzhida_fenmian_text2 {
          float: left;
          width: 120px;
          height: 19px;
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          line-height: 30px;
          margin-left: 267px;
          margin-top: 19px;
        }
      }

      .main_fuwuzhida_neirong {
        width: 100%;
        height: 110px;
        //margin-left: 15px;
        margin-bottom: 20px;
        background: #FFFFFF;
        float: left;
      }
    }

    .main_tesefuwuzhida_jiange {
      width: 100%;
      height: 51px;
    }

    .main_tesejiance {
      width: 80%;
      max-width: 1200px;
      height: 399px;
      background: #FFFFFF;
      border-radius: 3px;
      margin-right: auto;
      margin-left: auto;

      .main_jiance_fenmian {
        //background-image: url("../../../assets/home/jiance_fengmian.png");
        width: 100%;
        height: 399px;
        //background: #6783F9;
        //opacity: 0.3;
        border-radius: 3px;
        float: left;
      }

      .main_jiance_fenmian_juxing {
        //width: 195px;
        width: 18%;
        max-width: 195px;
        height: 92px;
        background: #000000;
        opacity: 0.6;
        border-radius: 20px 3px 40px 3px;
        position: absolute;
        margin-top: 46px;
        margin-left: 20px;

        .main_jiance_fenmian_juxing_text {
          width: 106px;
          height: 25px;
          font-size: 26px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 30px;
          margin-top: 22px;
          margin-left: 28px;
        }

        .main_jiance_fenmian_juxing_text2 {
          //width: 66px;
          height: 15px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 30px;
          margin-left: 28px;
          margin-top: 3px;
        }
      }

      .main_jiance_jiange {
        position: absolute;
        margin: 199px 47px 0 283px;
        float: left;
        width: 870px;
        height: 1px;
        background: #E1E1E1;
      }

      .main_jiance_sj {
        position: relative;
        width: 100%;
        height: 399px;
        float: left;
        //border-right: #E1E1E1 solid 1px;
        .main_jiance_sj_neirong {
          //border-right: #E1E1E1 solid 1px;
          float: left;
          //margin: 41px 0 41px 0;

          align-content: center;
          //width: 193px;
          //height: 117px;
          //background: #aa7700;
          .main_jiance_sj_neirong_img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .main_jinpaijiance_jiange {
      width: 100%;
      height: 70px;
    }

    .main_width {
      width: 80%;
      max-width: 1200px;
      margin-right: auto;
      margin-left: auto;

      .main_jinpai_top {
        width: 100%;
        height: 94px;
        background-color: #FFFFFF;
        margin-bottom: 7px;

        .main_jinpai_top_img {
          margin-top: -10px;
        }

        .main_jinpai_top_img2 {
          margin-top: 26px;
          margin-left: -450px;
          width: 33px;
          height: 40px;
          position: absolute;
        }

        .main_jinpai_top_text {
          //width: 216px;
          //height: 40px;
          font-size: 40px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #FFFFFF;
          //line-height: 30px;
          margin-top: -95px;
          margin-left: 85px;
        }

        .main_jinpai_top_text2 {
          //width: 74px;
          //height: 19px;
          float: right;
          margin-top: -40px;
          margin-right: 40px;
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          line-height: 30px;
        }
      }

      .main_jinpai {
        .main_gcs_liebiao {
          float: left;
          //width: 380px;
          height: 200px;
          background: #FFFFFF;
          //margin-right: 20px;
          border-radius: 10px;
          margin-top: 150px;

          .main_gcs_liebiao_top {
            width: 100%;
            height: 55px;


            .main_gcs_liebiao_top_img {
              width: 135px;
              height: 135px;
              //border-radius: 50%;
              margin-top: -110px;
              margin-left: 120px;
              position: absolute;
            }
          }

          .jinpai_name {
            margin-top: 55px;
            margin-left: 95px;
          }

          .jinpai_zhicheng {
            margin-top: 55px;
            margin-left: 15px;
          }

          .jinpai_jingli {
            margin: 30px 24px 0 29px;
          }
        }

      }

    }

    .main_jinpai_bottom {
      position: relative;
      width: 100%;
      height: 231px;
    }

    .main_phone_shaixuan {

    }
  }
}
</style>